module.exports = __webpack_public_path__ + "static/media/catMew.88ff1739.png";